import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

import { Button } from './button';

export function ErrorBoundary() {
	const error = useRouteError();

	useEffect(() => {
		if (!isRouteErrorResponse(error)) {
			Sentry.captureException(error);
		}
	}, [error]);

	if (isRouteErrorResponse(error) && error.status === 403) {
		return (
			<div className="flex h-screen w-full flex-col items-center justify-center">
				<p>You're not authorized to access this page</p>
				<Button asChild>
					<Link to={'/'}>Go Back</Link>
				</Button>
			</div>
		);
	}
	if (isRouteErrorResponse(error) && error.status === 404) {
		return (
			<div className="flex h-screen w-full flex-col items-center justify-center">
				<p>Page you're looking for didn't exists</p>
				<Button asChild>
					<Link to={'/'}>Go Back</Link>
				</Button>
			</div>
		);
	}

	return (
		<div className="flex h-screen w-full flex-col items-center justify-center space-y-4">
			<p className="text-lg font-medium text-red-600">
				An unexpected application error occurred.
			</p>
			<Button asChild onClick={() => window.location.reload()}>
				<span>Reload Page</span>
			</Button>
		</div>
	);
}

export function ErrorQuery({ message }: Readonly<{ message: string }>) {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center">
			{message}
		</div>
	);
}
